import React from 'react';
import CustomerFullInfoControlPanel from './components/CustomerFullInfoControlPanel/CustomerFullInfoControlPanel';
import Tabs from './components/Tabs/Tabs';

const CustomerFullInfoModal: React.FC = () => {
	return (
		<>
			<CustomerFullInfoControlPanel />
			<Tabs />
		</>
	);
};

export default CustomerFullInfoModal;
